import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';
import moment from 'moment/moment';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { szltStatusFormatter } from '../../../utils/formatters';
import { getRegisterData } from '../reducer';
import { loadSmevCheckSZLTList, smevCheckAllSZLT } from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';
import SZLTViewData from './SZLTViewData';
import CarrierMiniGrid from './CarrierMiniGrid';
import VehiclesMiniGrid from './VehiclesMiniGrid';
import DocumentList from '../../Application/components/DocumentList';
import { RegistryRelationHistoryDialog } from './RegistryRelationHistoryDialog';
import RegistryPageModal from './RegistryPageModal';
import ApplicationLegend from '../../Application/components/ApplicationLegend';
import { APPLICATION_STATUS, REGION_REGISTRY_RELATION } from '../../../configs';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import MobileSmevChecker from './MobileSmevChecker';

export default function MobileSZLTView(props) {
  const dispatch = useDispatch();
  const {
    onClose = () => {},
    loadData = () => {},
    formMeta,
  } = props;
  const [fullscreen, setFullscreen] = useState(false);
  const [isHistoryPopUp, setIsHistoryPopUp] = useState(false);
  const [isSameRegistryPopUp, setIsSameRegistryPopUp] = useState(false);
  const {
    currentSZLT = {},
    smevCheckSZLTList = [],
    loadingCheckAllSzlt,
  } = useSelector(getRegisterData);

  useEffect(() => {
    dispatch(loadSmevCheckSZLTList(currentSZLT.id)).catch(responseLogWithNotification);
  }, []);

  return ReactDOM.createPortal(
    <div className="application-form">
      <TimerLoader loading={loadingCheckAllSzlt} />
      <div className="mobile-application-form">
        <div className="mobile-header">
          <div className="application-number">
            <div className="application-text">
              Запись СЗЛТ №{currentSZLT.number}
            </div>
            <div className="legend-button">
              <Icons width={24} height={24} customIcon icon="helper" className="legend-icon" />
              <ApplicationLegend />
            </div>
          </div>
          <div className="application-status-block">
            {szltStatusFormatter(currentSZLT.status)}
            <div className="afc-header-link-same mobile-header-link ms-auto">
              <Icons
                customIcon
                icon="same-registry"
                className="history-icon"
                onClick={() => setIsSameRegistryPopUp(true)}
              />
              {isSameRegistryPopUp
                ? (
                  <RegistryPageModal
                    type="szlt"
                    onClose={() => setIsSameRegistryPopUp(false)}
                    customFilter={{
                      inn: currentSZLT?.inn,
                    }}
                    title="Реестровые записи в отношении данного СЗЛТ"
                    filterName="szlt-same-list-modal-filter"
                  />
                ) : null}
            </div>

            <NavLink
              className="mobile-header-link"
              to={{
                pathname: '/application',
                search: new URLSearchParams({
                  filter: 'carrier',
                  status: Object.values(APPLICATION_STATUS),
                  number: currentSZLT.number,
                  created_at: [moment(currentSZLT.created_at).subtract(1, 'year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
                }).toString(),
              }}
              target="_blank"
            >
              <Icons
                customIcon
                className="history-icon"
                icon="show-relation-link"
              />
            </NavLink>
            <NavLink
              className="mobile-header-link"
              to={{
                pathname: '/region-registry/history',
                search: new URLSearchParams({
                  subject_id: currentSZLT.id,
                  subject_type: 'order_service',
                }).toString(),
              }}
              target="_blank"
            >
              <Icons
                customIcon
                className="history-icon"
                icon="history-relation"
              />
            </NavLink>
          </div>
        </div>
        <div className="smev-info-block">
          <div className="smev-info-title f4">
            Перечень запросов СМЭВ/СМЭВ СПб
          </div>
          <div className="smev-info-button" onClick={() => setFullscreen(!fullscreen)}>
            <Icons
              customIcon
              icon={fullscreen ? 'full-screen-close' : 'full-screen'}
            />
          </div>
          {fullscreen ? (
            <MobileSmevChecker
              list={smevCheckSZLTList}
              current={currentSZLT}
              startCheckAction={smevCheckAllSZLT}
              loadData={loadData}
              handleClose={() => setFullscreen(false)}
            />
          ) : null}
        </div>
        <div className="mobile-application-data custom-scroll-theme">
          <SZLTViewData currentSZLT={currentSZLT} formMeta={formMeta} />
          <div className="hr-row" />
          <AccordionWithPreview
            title="Документы"
            content={(
              <DocumentList
                id={currentSZLT?.id}
                loadData={loadData}
              />
            )}
          />
          <VehiclesMiniGrid
            params={{
              order_service_id: currentSZLT.id,
            }}
            setIsHistoryPopUp={setIsHistoryPopUp}
            isCarrierRelationType={false}
          />
          <CarrierMiniGrid
            params={{
              order_service_id: currentSZLT.id,
            }}
            setIsHistoryPopUp={setIsHistoryPopUp}
            isVehicleRelationType={false}
          />
          {isHistoryPopUp ? (
            <RegistryRelationHistoryDialog
              currentCarrier={currentSZLT}
              subject_type="order_service"
              subject_id={currentSZLT?.id}
              log_name={isHistoryPopUp === 'vehicle' ? REGION_REGISTRY_RELATION.CARRIER_VEHICLE : REGION_REGISTRY_RELATION.ORDER_SERVICE_CARRIER}
              onClose={() => setIsHistoryPopUp(false)}
            />
          ) : null}
        </div>
        <div className="mobile-application-footer">
          <Button variant="secondary" onClick={onClose}>Закрыть</Button>
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
